import { deleteTour } from "../../data/repository/tourRepo";

export const deleteTourUseCase = async (id) => {
  const response = await deleteTour(id);
  return response;
};
